'use strict';
const angular = require('angular');
const {isFunction, isNumber} = angular;

var textShortTemplate = require('./field-templates/text-short/builder-edit.html');
var textLongTemplate = require('./field-templates/text-long/builder-edit.html');
var dateTemplate = require('./field-templates/date/builder-edit.html');
var durationTemplate = require('./field-templates/duration/builder-edit.html');
var scaleTemplate = require('./field-templates/scale/builder-edit.html');
var listTemplate = require('./field-templates/list/builder-edit.html');
var locationTemplate = require('./field-templates/location/builder-edit.html');
var fileTemplate = require('./field-templates/file/builder-edit.html');
var referenceLinkTemplate = require('./field-templates/reference-link/builder-edit.html');

module.exports.directive = [
  'TransformerDirectiveFactory',
  FormFieldBuilderEditInternalDirective];

module.exports.controller = [
  '$scope',
  '$element',
  '$attrs',
  'HashMap',
  FormFieldBuilderInternalController];

module.exports.templates = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('forms/text-short/builder-edit.html', textShortTemplate);
  $templateCache.put('forms/text-long/builder-edit.html', textLongTemplate);
  $templateCache.put('forms/date/builder-edit.html', dateTemplate);
  $templateCache.put('forms/duration/builder-edit.html', durationTemplate);
  $templateCache.put('forms/scale/builder-edit.html', scaleTemplate);
  $templateCache.put('forms/list/builder-edit.html', listTemplate);
  $templateCache.put('forms/location/builder-edit.html', locationTemplate);
  $templateCache.put('forms/file/builder-edit.html', fileTemplate);
  $templateCache.put('forms/reference-link/builder-edit.html', referenceLinkTemplate);
}

function FormFieldBuilderEditInternalDirective(TransformerDirectiveFactory) {
  var transformConfig = {
    controllerAs: 'formFieldBuilderInternal',
    bindToController: true,
    modes: [
      {name: 'text_short', templateUrl: 'forms/text-short/builder-edit.html', defaultMode: true},

      {name: 'text_long', templateUrl: 'forms/text-long/builder-edit.html'},

      {name: 'date', templateUrl: 'forms/date/builder-edit.html'},

      {name: 'duration', templateUrl: 'forms/duration/builder-edit.html'},

      {name: 'scale', templateUrl: 'forms/scale/builder-edit.html'},

      {name: 'list', templateUrl: 'forms/list/builder-edit.html'},

      {name: 'location', templateUrl: 'forms/location/builder-edit.html'},

      {name: 'file', templateUrl: 'forms/file/builder-edit.html'},

      {name: 'reference_link', templateUrl: 'forms/reference-link/builder-edit.html'}
    ]
  };

  return {
    restrict: 'E',
    template: '',
    scope: {
      currentMode: '=?',
      model: '=',
      typeData: '=?',
      builderEditorApi: '=?'
    },
    controllerAs: 'formFieldBuilderInternal',
    bindToController: true,
    controller: 'FormFieldBuilderInternalController',
    compile: TransformerDirectiveFactory(transformConfig)
  }
}

//TODO: determine a way to cache the reference data while editing the field. if the user changes the type back and forth, the selected data types should still be there.
function FormFieldBuilderInternalController($scope, $element, $attrs, HashMap) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/
  var vm = this;
  var currentModeWatchers = [];
  vm.typeData = vm.typeData || {};
  vm.focusIndex = -1;

  $scope.$watch(function () {
    return vm.currentMode;
  }, function (mode) {
    cancelModeWatchers();
    switch (mode) {
      case 'list':
        initItemWatcher();
        break;
      case 'reference_link':
        //initReferences();
        initReferencesWatcher();
        break;
    }
  });

  function cancelModeWatchers() {
    var i = currentModeWatchers.length;
    while (i--) {
      isFunction(currentModeWatchers[i]) && currentModeWatchers[i]();
      currentModeWatchers.pop();
    }
  }


  /*****************************************************************************************************************
   * list specific functionality
   ****************************************************************************************************************/

  vm.addItem = addItem;
  vm.removeIfEmpty = removeIfEmpty;
  vm.upIndex = upIndex;
  vm.downIndex = downIndex;

  function initItems() {
    if (vm.model && vm.model.options && vm.model.options.items && vm.model.options.items.length) {
    } else {
      addItem();
    }
  }

  function initItemWatcher() {
    currentModeWatchers.push($scope.$watch(function () {
      return vm.model && vm.model.options && vm.model.options.items && vm.model.options.items.length;
    }, function () {
      initItems();
    }));
  }

  // Array#push returns the new length of the array
  function addItem(index) {
    var item = {
      id: vm.model.options.next++,
      label: ''
    };

    if (isNumber(index) && ((index + 1) < vm.model.options.items.length)) {
      vm.model.options.items.splice(index + 1, 0, item);
      vm.focusIndex = index + 1;
    } else {
      vm.focusIndex = Math.max(vm.model.options.items.push(item) - 1, 0);
    }
  }

  function removeIfEmpty(index, label, goBack) {
    if (!label) {
      vm.model.options.items.splice(index, 1);
      if (goBack || index === vm.model.options.items.length) {
        vm.focusIndex = Math.max(index - 1, 0);
      }
      return true;
    }
  }

  function upIndex(index) {
    if (index > 0) {
      vm.focusIndex = index - 1;
    }
  }

  function downIndex(index) {
    if (index + 1 === vm.model.options.items.length) {
      addItem();
    } else {
      vm.focusIndex = index + 1;
    }
  }


  /*****************************************************************************************************************
   * reference_link specific functionality
   ****************************************************************************************************************/

  function initReferences() {
    vm.typeData.references = [
      {collection: 'personnel', label: 'Contacts', value: false},
      {collection: 'teams', label: 'Teams', value: false},
      {collection: 'assets', label: 'Assets', value: false},
      {collection: 'projects', label: 'Projects', value: false}
    ];

    if (vm.model && vm.model.options && vm.model.options.domainCollections && vm.model.options.domainCollections.length) {
      var keys = new HashMap();
      var i = vm.model.options.domainCollections.length;
      while (i--) {
        keys.put(vm.model.options.domainCollections[i].collection, true);
      }

      i = vm.typeData.references.length;
      while (i--) {
        if (keys.get(vm.typeData.references[i].collection)) {
          vm.typeData.references[i].value = true;
        }
      }
    }
  }

  function initReferencesWatcher() {
    currentModeWatchers.push($scope.$watch(function () {
      return vm.model && vm.model.options && vm.model.options.domainCollections && vm.model.options.domainCollections.length;
    }, function () {
      initReferences();
    }));
  }
}


// WEBPACK FOOTER //
// ./src/js/forms/directives/FormFieldBuilderEditInternalDirective.js